/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { AuthTokenResponse } from './AuthTokenResponse'
import {
  AuthTokenResponseFromJSON,
  AuthTokenResponseFromJSONTyped,
  AuthTokenResponseToJSON,
} from './AuthTokenResponse'

/**
 *
 * @export
 * @interface Login200Response
 */
export interface Login200Response {
  /**
   *
   * @type {boolean}
   * @memberof Login200Response
   */
  status: boolean
  /**
   *
   * @type {AuthTokenResponse}
   * @memberof Login200Response
   */
  data: AuthTokenResponse
}

/**
 * Check if a given object implements the Login200Response interface.
 */
export function instanceOfLogin200Response(
  value: object
): value is Login200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function Login200ResponseFromJSON(json: any): Login200Response {
  return Login200ResponseFromJSONTyped(json, false)
}

export function Login200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): Login200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: AuthTokenResponseFromJSON(json['data']),
  }
}

export function Login200ResponseToJSON(value?: Login200Response | null): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: AuthTokenResponseToJSON(value['data']),
  }
}
